import "./TechnicalSpecs.css";

import {
  FaBasketballBall,
  FaSun,
  FaCloudSunRain,
  FaShoePrints,
  FaAward,
  FaTools,
  FaGlobeAsia,
  FaShieldAlt,
} from "react-icons/fa";

const icons = [
  FaBasketballBall,
  FaSun,
  FaCloudSunRain,
  FaShoePrints,
  FaAward,
  FaTools,
  FaGlobeAsia,
  FaShieldAlt,
];

const TechnicalSpecs = ({ data }) => {
  return (
    <section className="technical-specs">
      <div className="technical-container">
        <div className="technical-heading">
          <span className="section-tag-technical">
            TECHNICAL SPECIFICATIONS
          </span>

          <h2>Built According to International Standards</h2>

          <p>
            Our Courts are engineered using premium materials and follow
            international construction standards to deliver long-term
            performance and player safety.
          </p>
        </div>

        <div className="technical-grid">
          {data.specifications.map((item, index) => {
            const Icon = icons[index % icons.length];

            return (
              <div className="technical-card" key={index}>
                <div className="technical-icon">
                  <Icon />
                </div>

                <h3>{item.feature}</h3>

                <p>{item.value}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TechnicalSpecs;
